import { render, staticRenderFns } from "./getting-started-checklist.vue?vue&type=template&id=def35078&scoped=true&"
import script from "./getting-started-checklist.vue?vue&type=script&lang=js&"
export * from "./getting-started-checklist.vue?vue&type=script&lang=js&"
import style0 from "./getting-started-checklist.vue?vue&type=style&index=0&id=def35078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def35078",
  null
  
)

export default component.exports